import { Injectable } from '@angular/core';
import { ErrorHandler } from '@angular/core/src/error_handler';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';

@Injectable()
export class GlobalErrorHandlerService implements ErrorHandler {

  constructor() { }

  handleError(error) {
    if (error instanceof HttpErrorResponse) {
      if (error.status === 401) {
        localStorage.removeItem('currentUser');
        window.location.replace('');
      }
    }
    console.log('Error : ' + error);
    throw error;
  }

}
